import angular from 'angular';
import openServiceOptionModal from './openServiceOptionModal';
import './style.scss';

export default angular
  .module('helloBook.scenes.openServiceOptionModal', [])
  .component('openServiceOptionModal', openServiceOptionModal).name;
